import React, { useState } from "react"
import { Row, Tooltip } from "antd"
import { connect } from "react-redux"
import SuggestedRestaurant from "../SuggestedRestaurant/SuggestedRestaurant"
import AutoCompleteRestaurants from "../RestaurantAutoSuggest/RestaurantAutoSuggest"
import _ from "../../utils/lodashUtils"
import {
  RESTAURANT_COUNT,
  YOUR_SUGGESTION,
  SUGGESTION_REJECTED,
  POWERED_BY,
  COMBINED_ORDER_LABEL,
  COMBINED_ORDER_TOOLTIP,
} from "../../constants/messages"
import "./ChooseRestaurant.scss"
import { FirebaseContext, FIREBASE_STATE_KEYS } from "../../firebase"
import { SUGGESTION_STATES } from "../../constants/commons"
import { TextTag } from "../../atoms"
import delivery_com_img from "../../assets/images/deliveryTextIcon.png"
import searchIcon from "../../assets/images/SearchIcon.svg"
import Tag from "../Tag/Tag"
import Separator from "../Separator/Separator"

const RestaurantsMatchedHeader = (props) => {
  const { restaurantsCount, setRestaurantList, restaurantList } = props

  const { partnerState, userState, dateState } = React.useContext(
    FirebaseContext
  )
  const partnerName = _.get(partnerState, "userDetails.display_name")
  let suggestedRestaurant = {}
  const [isPopOverVisible, setIsPopOverVisible] = useState(false)
  const isOrderCombined = _.get(
    dateState,
    FIREBASE_STATE_KEYS.IS_ORDER_COMBINED
  )

  //suggested by partner
  const restaurantSuggestion = _.get(
    partnerState,
    `${FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT}`
  )
  if (
    restaurantSuggestion &&
    restaurantSuggestion[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
      SUGGESTION_STATES.PENDING
  ) {
    suggestedRestaurant = restaurantSuggestion
  }

  //suggested by me
  let pendingRestaurantSuggestion = {}
  const suggestedRestaurantByMe = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_RESTAURANT,
    {}
  )
  if (
    suggestedRestaurantByMe[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.PENDING
  ) {
    pendingRestaurantSuggestion = suggestedRestaurantByMe
  }

  const combinedOrdersToolTip = () => {
    isPopOverVisible ? setIsPopOverVisible(false) : setIsPopOverVisible(true)
  }

  return (
    <div id="ChooseRestaurant">
      {!_.isEmpty(suggestedRestaurant) ? (
        <div className="partner-suggested-me">
          <SuggestedRestaurant />
        </div>
      ) : null}
      {!_.isEmpty(pendingRestaurantSuggestion) ? (
        <div className="my-restaurant-suggestion">
          <div className="your-suggestion-container">
            {YOUR_SUGGESTION(
              _.get(
                pendingRestaurantSuggestion,
                FIREBASE_STATE_KEYS.RESTAURANT_NAME,
                ""
              )
            )}
          </div>
        </div>
      ) : null}
      {suggestedRestaurantByMe[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
        SUGGESTION_STATES.REJECTED && (
        <div className="my-restaurant-suggestion">
          <div className="your-suggestion-container">
            <TextTag>{SUGGESTION_REJECTED(partnerName)}</TextTag>
          </div>
        </div>
      )}

      <div id="dinnerPlanSection">
        <div id="dinnerPlan">
          <div className="dinner-restraunts-count">
            <TextTag
              textType="sectionHeading"
              className="dinnerRestrauntsCountText"
            >
              {RESTAURANT_COUNT(restaurantsCount)}
              {isOrderCombined && (
                <div className="combined-tag">
                  <Tooltip
                    trigger="click"
                    placement="right"
                    title={COMBINED_ORDER_TOOLTIP}
                    className="tag-container"
                  >
                    <Tag
                      text={COMBINED_ORDER_LABEL}
                      onClickIcon={combinedOrdersToolTip}
                      icon={true}
                    />
                  </Tooltip>
                </div>
              )}
            </TextTag>
          </div>
          <Separator />
          <Row id="HeaderRow">
            <section id="dinnerPlanInput">
              <div className="searchbar-hotel">
                <img className="search-icon" src={searchIcon} alt="location" />
                <AutoCompleteRestaurants
                  setRestaurantList={setRestaurantList}
                  restaurantList={restaurantList || []}
                />
              </div>
            </section>
          </Row>
          <Row>
            <div className="delivery">
              <TextTag textType="smallTextPrimary">{POWERED_BY}</TextTag>
              <img src={delivery_com_img} alt="delivery.com" />
            </div>
          </Row>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user.username,
    partners: state.invitePeople.partnerDetails,
  }
}

export default connect(mapStateToProps, {})(RestaurantsMatchedHeader)
